<h1 class="flex justify-center ph3 mt5 pt1-ns mb3 core-blue l-heading">{{ (flightTrackerText$ | async)?.heading }}</h1>
<jb-flight-tracker-search [messages]="messages"></jb-flight-tracker-search>
